import React from "react";
import { Title, Text, ButtonLink, Button } from "components/commons";
import { useRouter } from "hooks";
import classNames from "classnames";
import { StyleType } from "enums";

const HeaderB = ({
  title,
  customTitle = null,
  description,
  customDescription = null,
  returnText,
  returnPath,
  onClick,
  loading,
  button,
  secondaryButton,
  className,
  customActions,
}) => {
  const { location, history } = useRouter();
  const { state } = location;
  const { fromList } = state || {};
  const {
    path,
    text,
    disabled: primaryDisabled = false,
    loading: primaryLoading = false,
    onClick: onClickPrimary,
    iconPrefix,
    type,
  } = button || {};

  const {
    text: secondaryButtonText,
    disabled: secondaryDisabled = false,
    loading: secondaryLoading = false,
    onClick: onClickSecondary,
    iconPrefix: secondaryIconPrefix,
  } = secondaryButton || {};

  return (
    <div className="md:mb-lg mb-sm">
      <div>
        <ButtonLink
          loading={loading}
          icon="arrow-left"
          className="-mx-2"
          path={fromList ? null : returnPath}
          onClick={
            fromList
              ? () => {
                  window.history.back();
                }
              : onClick
          }
          flex={false}
        >
          {returnText}
        </ButtonLink>
      </div>
      <div className={classNames(className, "md:flex items-center justify-between")}>
        <div>
          <Title xl className="font-semibold">
            {title}
          </Title>
          {customTitle}
          {description && <Text className="pb-sm text-gray">{description}</Text>}
          {customDescription}
        </div>
        <div>
          {secondaryButton && (
            <Button
              type={StyleType.Secondary}
              loading={secondaryLoading}
              disabled={secondaryDisabled}
              className="ml-0 mt-sm md:ml-md"
              onClick={
                onClickSecondary
                  ? () => {
                      onClickSecondary();
                    }
                  : null
              }
              iconPrefix={secondaryIconPrefix}
            >
              {secondaryButtonText}
            </Button>
          )}
          {button && (
            <Button
              type={type}
              loading={primaryLoading}
              disabled={primaryDisabled}
              className="ml-0 mt-sm md:ml-md"
              onClick={
                onClickPrimary
                  ? () => {
                      onClickPrimary();
                    }
                  : () => {
                      if (path) {
                        history.push(path);
                      }
                    }
              }
              iconPrefix={iconPrefix}
            >
              {text}
            </Button>
          )}
          {customActions}
        </div>
      </div>
    </div>
  );
};

export default HeaderB;
